(function ($) {

'use strict';

	/**
	 * check if the passes element is in view
	 * @returns {Boolean}
	 */
	$.fn.isElementInViewport = function () {
		if ($(this).length < 1) {
			return 0;
		}

		var chkElem = $(this)[0];

		var rect = chkElem.getBoundingClientRect();

		return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <= $(window).height() &&
				rect.right <= $(window).width()
				);
	};

}(jQuery));